//TODO: Use these in animation AnimatedContent component
const transitions = {};

export default transitions;
